import { render } from "./multiTicketPDF.vue?vue&type=template&id=f80a45f6"
import script from "./multiTicketPDF.vue?vue&type=script&lang=js"
export * from "./multiTicketPDF.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__